import Vue from 'vue';
import Router from 'vue-router';
import {getCookie} from "@components/util/cookie";
import { checkGrayItem } from '@util/handleGrayByLocalstorage';

const Register = r => require.ensure([], () => r(require('../Register/Register.vue')), 'Register');
const FindBelongId_Gray = r => require.ensure([], () => r(require('../BelongId/FindBelongId_Gray.vue')), 'Password');
const FindPassword = r => require.ensure([], () => r(require('../Password/FindPassword.vue')), 'Password');
const FindByPhone_Gray = r => require.ensure([], () => r(require('../FindByPhone/FindByPhone_Gray.vue')), 'FindByPhone');
const Login = r => require.ensure([], () => r(require('../Login/Login.vue')), 'Login');
Vue.use(Router);


export default new Router({
  routes: [
    {
      path: '/Register',
      name: 'Register',
      component: Register,
      meta: {
        cid: 'c_eco_9ihg0i28'
      }
    }, {
      path: '/Forget',
      name: 'Forget',
      component: FindByPhone_Gray,
    }, {
      path: '/FindBelongId',
      name: 'FindBelongId',
      component: FindBelongId_Gray,
      meta: {
        cid: 'c_46e4dpr9'
      }
    }, {
      path: '/FindPassword',
      name: 'FindPassword',
      component: FindPassword,
      meta: {
        cid: 'c_4ju07wr7'
      }
    }, {
      path: '/FindByPhone',
      name: 'FindByPhone',
      component: FindByPhone_Gray,
      meta: {
        cid: 'c_eco_fb7z6y8a'
      }
    }, {
      path: '/:id',
      name: 'Login',
      component: Login,
      meta: {
        cid: 'c_b46ba9ij'
      }
    }, {
      path: '/:id/:name',
      name: 'Login',
      component: Login,
      meta: {
        cid: 'c_b46ba9ij'
      }
    }, {
      path: '/',
      name: 'Login',
      component: Login,
      meta: {
        cid: 'c_b46ba9ij'
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/routers/Account/router.js